document.addEventListener('click', function (e) {
  const productPage = window.location.pathname.includes('/products/');

  if (!productPage) return;

  const img = e.target.closest('.product-media-container img, product-media img');

  if (!img) return;
  if (img.closest('.product-card, product-card, .related-products, .recommendations, .product-recommendations')) return;
  if (img.closest('.glo, .globo, [data-swatch], .product-form, variant-picker, product-form')) return;

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

const gallery =
  img.closest('media-gallery') ||
  img.closest('product-media-gallery') ||
  img.closest('.product-media-gallery') ||
  img.closest('.product__media-gallery') ||
  img.closest('.product-media');

if (!gallery) return;

const images = Array.from(
  gallery.querySelectorAll('.product-media-container img, product-media img')
).filter(i =>
  i.src &&
  i.width > 150 &&
  i.height > 150 &&
  i.offsetParent !== null &&
  getComputedStyle(i).display !== 'none' &&
  getComputedStyle(i).visibility !== 'hidden' &&
  getComputedStyle(i).opacity !== '0'
);

  const srcs = [...new Set(images.map(i => i.currentSrc || i.src))];

  let index = srcs.indexOf(img.currentSrc || img.src);
  if (index < 0) index = 0;

  document.querySelector('#custom-lightbox-test')?.remove();

  const overlay = document.createElement('div');
  overlay.id = 'custom-lightbox-test';
  overlay.style.cssText = `
    position: fixed;
    inset: 0;
    z-index: 999999999;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  `;

  overlay.innerHTML = `
    <button id="clb-close" style="position:absolute;top:20px;right:20px;z-index:2;font-size:28px;">×</button>
    <button id="clb-prev" style="position:absolute;left:30px;z-index:2;font-size:34px;">‹</button>
    <img id="clb-img" src="${srcs[index]}" style="max-width:90vw;max-height:95vh;object-fit:contain;transform:scale(1.10);">
    <button id="clb-next" style="position:absolute;right:30px;z-index:2;font-size:34px;">›</button>
  `;

  document.body.appendChild(overlay);

  if (window.innerWidth <= 749) {
overlay.querySelector('#clb-close').style.cssText += `
  width:28px;
  height:28px;
  font-size:16px;
  background:transparent;
  border:none;
  opacity:0.4;
  `;

overlay.querySelector('#clb-prev').style.cssText += `
  width:28px;
  height:28px;
  left:18px;
  font-size:22px;
  background:transparent;
  border:none;
  opacity:0.4;
`;

overlay.querySelector('#clb-next').style.cssText += `
  width:28px;
  height:28px;
  right:18px;
  font-size:22px;
  background:transparent;
  border:none;
  opacity:0.4;
`;

}

  const lightboxImg = overlay.querySelector('#clb-img');

function show(i) {
  const direction = i > index ? 1 : -1;

  lightboxImg.style.transition = 'transform 0.25s ease, opacity 0.25s ease';
  lightboxImg.style.transform = `translateX(${-40 * direction}px) scale(1.10)`;
  lightboxImg.style.opacity = '0';

  setTimeout(() => {
    index = (i + srcs.length) % srcs.length;
    lightboxImg.src = srcs[index];

    lightboxImg.style.transition = 'none';
    lightboxImg.style.transform = `translateX(${40 * direction}px) scale(1.10)`;

    setTimeout(() => {
      lightboxImg.style.transition = 'transform 0.25s ease, opacity 0.25s ease';
      lightboxImg.style.transform = 'translateX(0) scale(1.10)';
      lightboxImg.style.opacity = '1';
    }, 20);
  }, 250);
}

  overlay.querySelector('#clb-close').onclick = () => overlay.remove();
  overlay.querySelector('#clb-prev').onclick = () => show(index - 1);
  overlay.querySelector('#clb-next').onclick = () => show(index + 1);
}, true);